enum StatusOrdemPagamento {
    Ativo = 1,
    Pago = 2,
    Inativo = 3,
}

export default StatusOrdemPagamento;
